import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getBirraPage = gql`
  ${seoFragment}
  query GetBirraPage($site: [String]) {
    birraPageEntries(site: $site) {
      ... on birraPage_Entry {
        id
        typeHandle
        title
        key
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        sezioneIntroProdotti {
          ... on sezioneIntroProdotti_Entry {
            sectionTitle
            text
            portrait: image
              @transform(format: "webp", width: 450, height: 180) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
          }
        }
        sezionePreFooter {
          ... on sezionePreFooter_Entry {
            sectionTitle
            text
          }
        }
      }
    }
    categories(site: $site) {
      ... on categoriaLievitoBirra_Category {
        id
        algoliaKey
        slug
        title
        key
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        generalHeader {
          ... on generalHeader_Entry {
            id
            generalHeaderTitle
            generalHeaderText
            sezioneImmagineVideoFull {
              ... on sezioneImmagineVideoFull_Entry {
                imageVideoTitle
                imageVideoText
                fullVideoUrlPreview
                fullVideoUrl
                fullVideoButtonText
                fullImage {
                  id
                  title
                }
                landscape: fullImage
                  @transform(format: "webp", width: 3840, height: 2160) {
                  id
                  url
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  width
                  height
                  title
                }
                mobile: fullImageMobile
                  @transform(format: "webp", width: 1000, height: 1500) {
                  id
                  url
                  width
                  srcset(sizes: ["750w", "1000w"])
                  height
                  title
                }
              }
            }
          }
        }
        sezioneTitoloTestoPagina {
          ... on sezioneTitoloTestoPagina_Entry {
            id
            sectionTitle
            text
          }
        }
        sezioneImmagineTesto {
          ... on sezioneImmagineTesto_Entry {
            id
            portrait: immagine
              @transform(format: "webp", width: 1500, height: 1780) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            coloreTitolo
            coloreSfondo
            sectionTitle
            text
            invertiOrdine
            label
            linkDefault
          }
        }
        sezioneIntroProdotti {
          ... on sezioneIntroProdotti_Entry {
            sectionTitle
            text
            portrait: image
              @transform(format: "webp", width: 450, height: 180) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
          }
        }
        sezionePreFooter {
          ... on sezionePreFooter_Entry {
            sectionTitle
            text
          }
        }
      }
      ... on sottocategoriaLievitoBirra_Category {
        id
        slug
        title
        key
        algoliaKey
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        sezioneIntroProdotti {
          ... on sezioneIntroProdotti_Entry {
            sectionTitle
            text
            portrait: image
              @transform(format: "webp", width: 450, height: 180) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
          }
        }
        sezionePreFooter {
          ... on sezionePreFooter_Entry {
            sectionTitle
            text
          }
        }
      }
    }
  }
`
